import type { FC } from 'react';

import { Typography } from '@/modules/perseo-billing/ui/react/src/components/beta';
import { PdsIcon } from '@/modules/perseo-billing/ui/react/src/components/gamma';

export const DeliveryNoviosInfo: FC = () => {
  return (
    <div className="co-flex co-gap-x-16px">
      <div className="co-flex co-flex-shrink-0 co-p-1">
        <PdsIcon
          icon="PdsNovios"
          className="co-w-54px"
          width={54}
          height={54}
        />
      </div>
      <div className="co-flex co-flex-col">
        <Typography color="primary" weight="semibold" leading="24px">
          Tipo de entrega
        </Typography>
        <Typography leading="16px" size="body2">
          La pareja podrá elegir el tipo de entrega o recibir el equivalente en
          dinero.
        </Typography>
      </div>
    </div>
  );
};

DeliveryNoviosInfo.displayName = 'DeliveryNoviosInfo';

export default DeliveryNoviosInfo;
